module.exports = __webpack_public_path__ + "img/approved_community.f601e19f.svg";